import { Link } from 'react-router-dom';
import Icon from '../Icon/Icon';
import './CarouselCard.scss';
import { formatImageUrl } from '../../services/content';
import { ICarouselItem } from '../../interfaces/content/IPage';
import DOMPurify from 'dompurify';

interface CarouselCardProps {
  item: ICarouselItem;
  variant: 'large' | 'medium';
}

interface SvgRendererProps {
  svg: string;
}

function SvgRenderer({ svg }: SvgRendererProps) {
  const cleanSvg = DOMPurify.sanitize(svg);

  return <div dangerouslySetInnerHTML={{ __html: cleanSvg }} />;
}

export default function CarouselCard({ item, variant }: CarouselCardProps) {
  return (
    <Link
      to={item.url ?? '#'}
      className={`carousel-card carousel-card--${variant}`}
    >
      <div
        className="carousel-card__image"
        style={{
          backgroundImage: `url(${
            item.thumbnailUrl || formatImageUrl(item.thumbnail)
          })`
        }}
      />

      <div className="carousel-card__footer">
        <div className="carousel-card__footer--left">
          {item.icon && !item?.icon?.startsWith('age') ? (
            <SvgRenderer svg={item.icon} />
          ) : (
            <Icon name={item?.icon || 'mic'} />
          )}
          <div>
            <p>{item.title}</p>
            <p>{item.description}</p>
          </div>
        </div>

        <div className="carousel-card__footer--right">
          <Icon name="arrowRight" />
        </div>
      </div>
    </Link>
  );
}
